import { render } from "./TermPage.vue?vue&type=template&id=727fbfd6"
import script from "./TermPage.vue?vue&type=script&lang=js"
export * from "./TermPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__